// extracted by mini-css-extract-plugin
export default {"paletteColors":"SingleColorPalette_paletteColors__iPWhV","goBack":"SingleColorPalette_goBack__DMh4J","backBtn":"SingleColorPalette_backBtn__ED2gg"};